<script setup>
// Documents with nothing to show (phase 4.2, D-G5): the kit's Empty over faded kit DocumentCards with neutral
// examples (POLARIS.PAGES.EXAMPLES). The invitation that used to sit here is now the page's Invitation.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DocumentCard from 'dashboard/components-next/polaris/cards/DocumentCard.vue';
import PolarisEmptyState from './PolarisEmptyState.vue';

const emit = defineEmits(['click']);

const { t, tm, rt } = useI18n();

const examples = computed(() =>
  tm('POLARIS.PAGES.EXAMPLES.DOCUMENTS').map((example, index) => ({
    name: rt(example.NAME),
    source: rt(example.SOURCE),
    pdf: index === 1,
    responses: [12, 4, 27][index] ?? 0,
  }))
);
</script>

<template>
  <PolarisEmptyState
    :title="t('POLARIS.DOCUMENTS.EMPTY_STATE.TITLE')"
    :description="t('POLARIS.DOCUMENTS.EMPTY_STATE.SUBTITLE')"
    :action-label="t('POLARIS.DOCUMENTS.ADD_NEW')"
    :action-perms="['administrator']"
    @click="emit('click')"
  >
    <template #backdrop>
      <DocumentCard
        v-for="example in examples"
        :key="example.name"
        v-bind="example"
      />
    </template>
  </PolarisEmptyState>
</template>
